import {
    Grid,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Dialog,
    Checkbox,
    Typography
} from "@material-ui/core"
import { useEffect, useState } from "react";
import React from 'react';
import Button from "@material-ui/core/Button";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import { CambiarEstadoCotizacion, aceptarCotizacion } from "../../../actions/compras/Cotizaciones";
import { startAlerta } from "../../../actions/ui/alertas";
import { ModalAvisoOferente } from "./ModalAvisoOferente";
import { ModalCargarCotizacion } from "./ModalCargarCotizacion";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";

let contador = 0;

export const ModalAceptarCotizacion = (props) => {
    const { cabeceraCotizacion, idEstado,idTipoSolicitud } = props;
    const dispatch = useDispatch();
    const oferentes = cabeceraCotizacion.map(x => x.oferentes);
    const [idOferente, setOferente] = useState();
    const [selected, setSelected] = useState([]);
    const [todos, setTodos] = useState(false);
    const [observaciones, setObservaciones] = useState("")
    const [esProveedor, setEsproveedor] = useState(false);
    const [open, setOpen] = useState(false);
    const [idOferenteEdicion, setIdOferenteEdicion] = useState(false);
    const [retornarSolicitadas, setRetornarSolicitadas] = useState(false);
    const [precioTotal, setPrecioTotal] = useState(0)

    const isSelected = (id) => selected.indexOf(id) !== -1;
    const handleAllSelectClick = (event, idOferente) => {
        if (event.target.checked && selected.length === 0) {
            const newSelecteds = cabeceraCotizacion.filter((a) => a.idOferente === idOferente).map((n) => n.detalleCotizaciones.map((q) => q.idDetalleCotizacion));
            setSelected(newSelecteds[0]);
            setOferente(idOferente);
            setTodos(!todos);
            return;
        }
        setSelected([]);
    }
    const handleClick = (event, idDetalleCotizacion) => {
        const selectedIndex = selected.indexOf(idDetalleCotizacion);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, idDetalleCotizacion);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleSave = () => {
        if (selected.length === 0) {
            dispatch(startAlerta("Debe seleccionar una cotizacion", "warning", `¡Error!`))
        } else {
            let data =
            {
                IdsDetallesCotizaciones: selected,
                ObservacionAceptacion: observaciones
            }
            dispatch(aceptarCotizacion(data, setEsproveedor, props.closeModalHandler, idEstado,idTipoSolicitud));
        }
    }
    const handleItemSelect = (item) => {
        setOpen(true);
        setIdOferenteEdicion(item);
    }

    useEffect(()=>{
        contador = 0;
        oferentes.forEach((o) => {
            cabeceraCotizacion.forEach((detalle) => (
                detalle.oferentes.idOferente === o.idOferente &&
                detalle.detalleCotizaciones.forEach((a, index) => {
                    const elementoSeleccionado = selected.find(item => item === a.idDetalleCotizacion);
                    if (elementoSeleccionado){
                        contador += a.cantidadCotizada * a.valorUnitario
                    }
                })
            ))
        })
        setPrecioTotal(contador)
    }, [selected])

    return (
        <div>
            {open &&
                (
                    <ModalCargarCotizacion
                        open={open}
                        closeModalHandler={() => {
                            setOpen(false);
                        }}
                        cabeceraCotizacion={cabeceraCotizacion}
                        idSolicitud={props.idSolicitud}
                        idEstado={idEstado}
                        cotizacion={null}
                        esEdicion={true}
                        idOferenteEdicion={idOferenteEdicion}
                    />
                )
            }
            <Dialog
                fullWidth
                maxWidth={'lg'}
                open={props.open}
            >
                <Grid>
                    <Typography variant="h5" align="center" style={{ margin: '1rem' }}>Cotizacion N° {props.idSolicitud}</Typography>
                    <Grid>
                        {oferentes.map((o) => {
                            return (
                                <Grid style={{ marginTop: '2rem' }}>
                                    <Table container size="small">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '1rem', color: '#68389F' }} >{`${o.razonSocial.toUpperCase()} - ${o.cuit}`}</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell ></TableCell>
                                                <TableCell ></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Material</TableCell>
                                                <TableCell>Cantidad Cotizada</TableCell>
                                                <TableCell>Precio Final</TableCell>
                                                <TableCell><Checkbox
                                                    onChange={(event) => handleAllSelectClick(event, o.idOferente)}
                                                    inputProps={{ "aria-label": "select all desserts" }}
                                                    checked={todos ? cabeceraCotizacion.find((a) => a.idOferente === o.idOferente).idOferente === idOferente && selected.length === cabeceraCotizacion.filter((a) => a.idOferente === o.idOferente).map((n) => n.detalleCotizaciones)[0].length : false}
                                                /></TableCell>
                                                <TableCell><Button variant="contained"
                                                    color="primary" onClick={() => handleItemSelect(cabeceraCotizacion.find((a) => a.idOferente === o.idOferente).idOferente)}>Editar</Button></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                cabeceraCotizacion.map((detalle) => (
                                                    detalle.oferentes.idOferente === o.idOferente &&
                                                    detalle.detalleCotizaciones.map((a, index) => {
                                                        const isItemSelected = isSelected(a.idDetalleCotizacion);
                                                        const labelId = `enhanced-table-checkbox-${index}`;
                                                        if (a.fechaBaja === null) {
                                                            return (
                                                                <React.Fragment>
                                                                    <TableRow
                                                                        key={index}
                                                                        hover
                                                                        role="checkbox"
                                                                        aria-checked={isItemSelected}
                                                                        tabIndex={-1}
                                                                        selected={isItemSelected}
                                                                    >
                                                                        <TableCell>{a.materiales?.descripcion}</TableCell>
                                                                        <TableCell>{a.cantidadCotizada}</TableCell>
                                                                        <TableCell>${a.cantidadCotizada * a.valorUnitario}</TableCell>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                name="aceptado"
                                                                                checked={isItemSelected}
                                                                                inputProps={{ "aria-labelledby": labelId }}
                                                                                disabled={props.esSoloInfo ? true : false}
                                                                                onClick={(event) => handleClick(event, a.idDetalleCotizacion)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </React.Fragment>
                                                            )
                                                        }
                                                        return null
                                                    })
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </Grid>

                            )
                        })
                        }
                         <Grid align="center" style={{ marginTop: '2rem' }}>
                            <Typography style={{ fontWeight: 'bold', fontSize: '1rem' }}> Total: ${precioTotal}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <ValidatorForm onSubmit={handleSave} >
                    <Grid container style={{ padding: '15px' }}>
                        <Grid item xs={12}>
                            <TextValidator
                                value={observaciones}
                                margin="normal"
                                label="Motivo de Aceptacion"
                                name="observaciones"
                                autoComplete="off"
                                validators={["required"]}
                                fullWidth
                                errorMessages={["El motivo de aceptación es requerido"]}
                                multiline
                                rowsMax={8}
                                onChange={(event) => { setObservaciones(event.target.value) }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{ padding: '15px' }}>
                        <Grid item xs={12}>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={()=>setRetornarSolicitadas(true)}
                                    style={{ textAlign: 'center', marginRight: '1rem' }}>
                                    Retornar a solicitadas
                                </Button>
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={()=>{
                                        setPrecioTotal(0)
                                        props.closeModalHandler()
                                    }}>
                                    Cerrar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ textAlign: 'center', marginLeft: '1rem' }}
                                    type='submit'
                                >
                                    Aceptar Cotizacion
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </ValidatorForm>
                {
                    esProveedor &&
                    <ModalAvisoOferente
                        open={esProveedor}
                        closeModalHandler={() => { setEsproveedor(false) }}
                        idEstado={idEstado}
                        idSolicitud={props.idSolicitud}
                    />
                }
                <AlertFinalizadoStepper
                    open={retornarSolicitadas}
                    pregunta={"Retornar a estado solicitadas"}
                    dialogText={`Esta seguro de que desea retornar esta cotizacion a "solicitadas"?`}
                    buttonCancel={"Cancelar"}
                    buttonSubmit={"Confirmar"}
                    handleClose={() => setRetornarSolicitadas(false)}
                    handleSend={() => {
                        setRetornarSolicitadas(false);
                        dispatch(CambiarEstadoCotizacion(props.idSolicitud,idTipoSolicitud));
                        dispatch(props.closeModalHandler);
                    }}
                />
            </Dialog>
        </div>
    )
}